import { postMessage } from "../../lib/post-message";
import axiosInstance from "./axiosInstance";

export const updateInpectionPointApi = async (
    token: string | null,
    inspection_id: number,
    data: any
) => {
    const response = await axiosInstance.post(
        `/Point/UpdateInspectionPoint/${inspection_id}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};


export const updateInspectionToProgressApi = async (
    token: string | null,
    workorder_id: number,
) => {
    const response = await axiosInstance.put(
        `/WorkOrders/InspectionInProgress?workOrder_ID=${workorder_id}`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response.data;
};


export const getPresignedUrlAPI = async (token: string, fileName: string) => {
    const response = await axiosInstance.get(`/Photo/GetPresignedUrl?filename=${fileName}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const updatePhotoUrlAPI = async (
    token: string | null,
    inspectionPointId: number,
    url: string,
    displayOrder: number
) => {
    try {
        const response = await axiosInstance.post(
            `/Point/${inspectionPointId}/Photo`,  // .NET API endpoint for updating photo URL
            { url, displayOrder },  // Pass URL in the request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to update photo URL:", error);
        postMessage({
            type: "RETRY_UPDATE_PHOTO_URL",
            payload: { token, inspectionPointId, url },
        });
        throw error;
    }
};